<template>
  <div class="activity_sign_up_container" :style="{paddingTop: statusBarHeight + 'px'}">
    <div class="back">
      <span class="back-arrow" @click="$router.back(-1)">
        <Icon iconClass="arrow-left2" />
      </span>
      <span>活动报名</span>
    </div>
    <div class="activity_sign_up_box">
      <div class="sign_up_box">
        <!-- 报名方式:1.线上报名;2.线下报名;3:线上+线下 -->
        <div class="sign_up_location" v-if="!!activity && (activity.applyType == 2 || activity.applyType == 3) && addressList.length > 0">
          <span>
            <Icon iconClass="locate" />
          </span>
          <span class="label">现场报名：</span>
          <van-notice-bar :text="addressList" :wrapable="false" />
        </div>
        <div class="sign_up_label" v-if="!!activity">
          <span>参与活动：</span>
          <span v-text="activity.activityName"></span>
        </div>
        <div class="sign_up_form_list">
          <div class="sign_up_form_item">
            <div class="sign_up_form_item_title">
              <span class="name">姓名</span>
              <span class="required">*</span>
            </div>
            <div class="sign_up_form_item_body">
              <input class="sign_up_input_text" type="text" placeholder="请输入您的真实姓名" v-model="username" ref="username" />
            </div>
          </div>
          <div class="sign_up_form_item">
            <div class="sign_up_form_item_title">
              <span class="name">手机号</span>
              <span class="required">*</span>
            </div>
            <div class="sign_up_form_item_body">
              <input class="sign_up_input_text" type="text" placeholder="请输入您的手机号码" v-model="phone" ref="phone" />
              <button class="send_code" ref="timeLocation" @click="sendCode($event)">
                发送验证码
              </button>
            </div>
          </div>
          <div :class="{ sign_up_form_item: true, item_no_border: applyForm.length==0 }">
            <div class="sign_up_form_item_title">
              <span class="name">验证码</span>
              <span class="required">*</span>
            </div>
            <div class="sign_up_form_item_body">
              <input class="sign_up_input_text" type="text" placeholder="请输入您获取到的手机验证码" v-model="code" ref="code" />
            </div>
          </div>
          <div :class="{ sign_up_form_item: true, item_no_border: applyForm.length==(index+1) }" v-for="(item,index) in applyForm" :key="index">
            <div class="sign_up_form_item_title" v-if="item.customType==6">
              <van-cell is-link @click="showSingleSelect(item)" v-if="item.required">
                <!-- 使用 title 插槽来自定义标题 -->
                <template #title>
                  <span v-text="item.displayName"></span>
                  <span class="required">*</span>
                </template>
              </van-cell>
              <van-cell is-link :title="item.displayName" @click="showSingleSelect(item)" v-else />
            </div>
            <div class="sign_up_form_item_title" v-else>
              <span class="name" v-text="item.displayName"></span>
              <span class="required" v-if="item.required">*</span>
            </div>
            <!-- 单行文本 -->
            <div class="sign_up_form_item_body" v-if="item.customType==1">
              <input class="sign_up_input_text" type="text" :placeholder="item.help" v-model="item.defualtValue" :maxlength="item.textLength" v-if="item.textLimited" />
              <input class="sign_up_input_text" type="text" :placeholder="item.help" v-model="item.defualtValue" v-else />
            </div>
            <!-- 多行文本 -->
            <div class="sign_up_form_item_body" v-else-if="item.customType==2">
              <textarea class="sign_up_textarea_text" :placeholder="item.help" v-model="item.defualtValue"></textarea>
            </div>
            <!-- 单选按钮 -->
            <div class="sign_up_form_item_body" v-else-if="item.customType==3">
              <div class="radio_list">
                <div :class="{radio:true,checked:option.isDefault==1}" v-for="(option,idx) in item.options" :key="index + '_' + idx" @click="onRadioClick(item.options,option);">
                  <input type="radio" :name="'radioGorup' + item.customId" :checked="option.isDefault==1">
                  <label v-text="option.label"></label>
                </div>
              </div>
            </div>
            <!-- 多选按钮 -->
            <div class="sign_up_form_item_body" v-else-if="item.customType==4">
              <div class="check_list">
                <div :class="{checkbox:true,checked:option.isDefault==1}" v-for="(option,idx) in item.options" :key="index + '_' + idx" @click="onCheckClick(option);">
                  <input type="checkbox" :name="'checkboxGorup' + item.customId" :checked="option.isDefault==1">
                  <label v-text="option.label"></label>
                </div>
              </div>
            </div>
            <!-- 下拉列表 -->
            <div class="sign_up_form_item_body" v-else-if="item.customType==6" @click="showSingleSelect(item)">
              <input class="sign_up_input_text" type="text" v-model="item.defualtValue" :placeholder="item.help" disabled />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="operate_box">
      <span class="operate_btn" @click="submitSignUp">提交报名</span>
    </div>
    <van-popup v-model="item.showPicker" round position="bottom" v-for="(item,index) in applyForm" :key="index">
      <van-picker show-toolbar :title="item.help" :columns="item.options" value-key="label" @cancel="item.showPicker = false" @confirm="onSingleSelectConfirm" v-if="item.customType==6" />
    </van-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { testMobilePhone, loadStat } from "@/utils";
import activityApi from "@/api/apis/activity.js";
import commApi from "@/api/apis/common.js";

export default {
  name: "SignUp",
  data() {
    return {
      params: {
        contentType: 1,
        activityId: null,
        cId: 0,
      },
      activity: null, // 活动详情
      applyForm: [], // 报名表单
      username: "",
      phone: "",
      code: "",
      timePicker: null,
      curItem: null, // 当前选中的下拉项
      isSubmited: false, // 控制网络不好时，提交报名被多次触发发送请求
      pageData: {
        title: "",
        info: "",
        shareUrl: "",
        imageUrl: ""
      },
    };
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode", "shareRootUrl", "statusBarHeight"]),
    addressList: function () {
      if (!!this.activity) {
        if (!!this.activity.applyOfflineAddress && this.activity.applyOfflineAddress.length > 0) {
          let str = "";
          let list = this.activity.applyOfflineAddress;
          for (var i = 0; i < list.length; i++) {
            if (list.length == 1) {
              str += list[i].province + list[i].city + list[i].county + list[i].address;
            } else {
              if (i == 0) {
                str += i + 1 + ". " + list[i].province + list[i].city + list[i].county + list[i].address;
              } else {
                str += " " + (i + 1) + ". " + list[i].province + list[i].city + list[i].county + list[i].address;
              }
            }
          }
          return str;
        } else {
          return this.activity.address;
        }
      } else {
        return "";
      }
    },
  },
  components: {},
  methods: {
    /* 获取活动详情 */
    getActivityDetail() {
      var _this = this;
      activityApi
        .getActivityDetail(_this.params)
        .then((res) => {
          if (res.suc == 1) {
            _this.activity = res.data;
            _this.pageData.title = _this.activity.activityName;
            var desc = _this.activity.description;
            if (!desc || desc.length == 0) {
              desc = _this.activity.activityName;
            }
            _this.pageData.info = desc;
            _this.pageData.imageUrl = _this.activity.sharePictureUrl;
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 获取报名表单 */
    getApplyMemberModel() {
      var _this = this;
      activityApi
        .getApplyMemberModelByActivityId(_this.params)
        .then((res) => {
          if (res.suc == 1) {
            let list = res.data.custom;
            for (var i = 0; i < list.length; i++) {
              list[i].options = JSON.parse(list[i].options);
              if (list[i].customType == 6) {
                list[i].showPicker = false;
              }
              if (list[i].defualtValue == undefined) {
                list[i].defualtValue = "";
              }
            }
            _this.applyForm = list;
          } else {
            console.log(res.message);
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 发送验证码 */
    sendCode(e) {
      var _this = this;
      if (testMobilePhone(_this.phone)) {
        var time = 59;
        if (_this.$refs.timeLocation) {
          _this.$refs.timeLocation.innerHTML = "请(" + time + ")秒后重新获取";
          _this.$refs.timeLocation.disabled = true;
        }
        _this.timePicker = setInterval(function () {
          time--;
          if (time == 0) {
            clearInterval(_this.timePicker);
            if (_this.$refs.timeLocation) {
              _this.$refs.timeLocation.innerHTML = "发送验证码";
              _this.$refs.timeLocation.disabled = false;
            }
          } else {
            if (_this.$refs.timeLocation) {
              _this.$refs.timeLocation.innerHTML = "请(" + time + ")秒后重新获取";
            }
          }
        }, 1000);

        var params = {
          mobilephone: _this.phone,
          nodeCode: _this.nodeCode,
        };
        commApi
          .getAuthCode(params)
          .then((res) => {
            if (res.suc == 1) {
              _this.$toast({
                message: "发送成功",
                position: "center",
              });
            } else {
              _this.$toast({
                message: "发送验证码失败,请稍后再试!",
                position: "center",
              });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      } else {
        _this.$toast({
          message: "请输入正确的手机号",
          position: "center",
        });
      }
    },
    /* 单选框组，选择操作 */
    onRadioClick(options, option) {
      if (option.isDefault == 0) {
        option.isDefault = 1;
        for (var i = 0; i < options.length; i++) {
          if (option.label != options[i].label) {
            options[i].isDefault = 0;
          }
        }
      }
    },
    /* 多选框组，选择操作 */
    onCheckClick(option) {
      if (option.isDefault == 0) {
        option.isDefault = 1;
      } else {
        option.isDefault = 0;
      }
    },
    /* 显示下拉选择 */
    showSingleSelect(item) {
      this.curItem = item;
      item.showPicker = true;
    },
    /* 下拉选择 点击确认 */
    onSingleSelectConfirm(value) {
      this.curItem.defualtValue = value.label;
      this.curItem.showPicker = false;
    },
    /* 提交报名 */
    submitSignUp() {
      var _this = this;

      // 控制不会连续发送请求
      if (_this.isSubmited) {
        return
      }

      let isPhone = testMobilePhone(_this.phone);

      if (!_this.userInfo) {
        _this.$toast({
          message: "请先登录！",
          position: "center",
        });
        return;
      } else if (_this.username.length == 0) {
        _this.$toast({
          message: "请填写您的真实姓名！",
          position: "center",
        });
        _this.$nextTick((x) => {
          _this.$refs.username.focus();
        });
        return;
      } else if (!isPhone) {
        _this.$toast({
          message: "请填写正确的手机号码！",
          position: "center",
        });
        _this.$nextTick((x) => {
          _this.$refs.phone.focus();
        });
        return;
      } else if (_this.code.length != 6) {
        _this.$toast({
          message: "请填写您获取到的验证码！",
          position: "center",
        });
        return;
      }

      var valueList = [];
      for (var i = 0; i < _this.applyForm.length; i++) {
        var item = _this.applyForm[i];
        var cdata = {};
        cdata.customUUID = item.customUUID;
        cdata.type = item.customType;
        // 单行文本 多行文本 下拉 级联下拉
        if (cdata.type == 1 || cdata.type == 2 || cdata.type == 5 || cdata.type == 6) {
          cdata.value = item.defualtValue;
        }
        // 单选
        else if (cdata.type == 3) {
          for (var j = 0; j < item.options.length; j++) {
            if (item.options[j].isDefault == 1) {
              cdata.value = item.options[j].label;
              break;
            }
          }
        }
        // 多选
        else if (cdata.type == 4) {
          var value = new Array();
          for (var j = 0; j < item.options.length; j++) {
            if (item.options[j].isDefault == 1) {
              value.push(item.options[j].label);
            }
          }
          if (value.length == 0) {
            cdata.value = "";
          } else {
            cdata.value = JSON.stringify(value);
          }
        }

        if ((cdata.type == 1 || cdata.type == 2) && item.required && cdata.value == "") {
          _this.$toast({
            message: item.displayName + "不能为空，请填正确填写！",
            position: "center",
          });
          return;
        }

        if ((cdata.type == 3 || cdata.type == 4 || cdata.type == 6) && item.required && cdata.value == "") {
          _this.$toast({
            message: item.displayName + "为必选，请选择！",
            position: "center",
          });
          return;
        }
        valueList.push(cdata);
      }

      _this.isSubmited = true;

      var params = {
        activityId: _this.params.activityId,
        memberId: _this.userInfo.id,
        name: _this.username,
        phone: _this.phone,
        validCode: _this.code,
        email: "",
        valueList: JSON.stringify(valueList),
      };
      activityApi
        .addApplyMember(params)
        .then((res) => {
          _this.isSubmited = false;
          if (res.suc == 1) {
            if (_this.activity.signUpRaffleId > 0) {
              _this.$dialog
                .confirm({
                  message: "报名成功，恭喜您获得一次抽奖机会，现在去抽奖？",
                  cancelButtonText: "放弃",
                  confirmButtonText: "去抽奖",
                })
                .then(() => {
                  _this.$router.replace({
                    path: "/raffle_detail",
                    query: {
                      contentType: 2,
                      freeFlag: 1,
                      drawRaffleId: _this.activity.signUpRaffleId,
                      type: _this.activity.signUpRaffleForm,
                    },
                  });
                })
                .catch(() => {
                  _this.$router.back(-1);
                });
            } else if (_this.activity.supportVote) {/* 支持评选时 */
              _this.$dialog
                .alert({
                  message: "报名成功，待审核后可上传作品！",
                })
                .then(() => {
                  _this.$router.back(-1);
                });
            } else {
              _this.$dialog
                .alert({
                  message: "报名成功！",
                })
                .then(() => {
                  _this.$router.back(-1);
                });
            }
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.isSubmited = false;
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
  },
  created() {
    document.title = "活动报名";
    var _this = this;
    let query = _this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "activityId")) {
      _this.params.activityId = Number(query.activityId);
      _this.getActivityDetail();
      _this.getApplyMemberModel(); // 获取报名表单

      // 定时器用来解决不能及时获取到用户信息的问题
      var tm = setInterval(function () {
        if (!!_this.userInfo) {
          clearInterval(tm);
          _this.username = _this.userInfo.nickName;
          _this.phone = _this.userInfo.mobilePhone;
        }
      }, 500);

      _this.pageData.shareUrl = _this.shareRootUrl + "index_share?contentType=" + _this.params.contentType + "&activityId=" + _this.params.activityId + "&contentCode=" + _this.nodeCode;
      // 提供给客户端调用，设置分享信息
      _this.$bridge.registerhandler("getShareInfo", function () {
        // 调用客户端方法，将分享信息传给客户端
        _this.$bridge.callhandler("setShareInfo", JSON.stringify(_this.pageData), function (res) { });
      });

      loadStat(); // 友盟统计
    } else {
      _this.$router.replace({
        path: "/error",
      });
    }
  },
};
</script>
<style scoped lang="scss">
.activity_sign_up_container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #fff;
  .activity_sign_up_box {
    width: 100%;
    height: calc(100% - 90px);
    background-color: #f6f6f6;
    .sign_up_box {
      position: relative;
      width: 100%;
      max-height: 100%;
      overflow-x: hidden;
      overflow-y: auto;
      background-color: #fff;
      .sign_up_location {
        display: flex;
        height: 36px;
        line-height: 36px;
        padding-left: 15px;
        padding-right: 15px;
        background-color: #edf4ff;
        .tj-svg-icon {
          color: #c5c5c5;
        }
        .label {
          margin-left: 10px;
          color: #666;
          font-size: 12px;
        }
        .van-notice-bar {
          flex: 1;
          height: 36px;
          padding: 0;
          background-color: #edf4ff;
          color: #397ef5;
        }
      }
      .sign_up_label {
        padding: 5px 15px;
        line-height: 24px;
        color: #222;
        font-size: 12px;
      }
      .sign_up_form_list {
        padding: 5px 15px;
        .sign_up_form_item {
          border-bottom: 1px solid #ececec;
          &.item_no_border {
            border: none;
          }
          .sign_up_form_item_title {
            line-height: 36px;
            color: #333;
            font-size: 18px;
            .name {
              font-size: 18px;
            }
            .required {
              margin-left: 5px;
              color: red;
            }
            .tips {
              margin-left: 5px;
              font-size: 14px;
            }
            .van-cell {
              line-height: 36px;
              padding: 0;
              background-color: #fff;
              color: #333;
              font-size: 18px;
              &:hover,
              &:active {
                background-color: #fff;
              }
              .van-icon.van-cell__right-icon {
                height: 36px;
                line-height: 36px;
              }
            }
          }
          .sign_up_form_item_body {
            position: relative;
            .sign_up_input_text {
              color: #333;
              width: 100%;
              padding-top: 5px;
              padding-bottom: 15px;
              background: none;
              border: none;
            }
            .send_code {
              position: absolute;
              right: 0;
              height: 24px;
              padding-left: 8px;
              padding-right: 8px;
              line-height: 24px;
              border: none;
              border-radius: 5px;
              font-size: 12px;
              &:disabled {
                padding-left: 4px;
                padding-right: 4px;
                background-color: #ececec;
                color: #8f8f8f;
                border-radius: 8px;
              }
            }
            .sign_up_textarea_text {
              color: #333;
              width: 100%;
              height: 240px;
              line-height: 24px;
              padding: 5px 0px;
              margin-bottom: 5px;
              // background: #f7f8fa;
              border: none;
              resize: none;
            }
            .radio_list {
              margin-bottom: 10px;
              .radio {
                line-height: 24px;
                padding: 8px 10px;
                border: 2px solid #ececec;
                border-radius: 5px;
                margin-bottom: 15px;
                &.checked {
                  border-color: #397ef5;
                }
                label {
                  margin-left: 5px;
                }
              }
            }
            .check_list {
              margin-bottom: 10px;
              .checkbox {
                line-height: 24px;
                padding: 8px 10px;
                border: 2px solid #ececec;
                border-radius: 5px;
                margin-bottom: 15px;
                &.checked {
                  border-color: #397ef5;
                }
                label {
                  margin-left: 5px;
                }
              }
            }
          }
        }
      }
    }
  }

  .operate_box {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 5;
    display: flex;
    width: 100%;
    height: 45px;
    background-color: #fff;
    border-top: 1px solid #ebedf0;
    .operate_btn {
      flex: 1;
      height: 45px;
      line-height: 45px;
      background-color: #397ef5;
      text-align: center;
      color: #fff;
      font-size: 16px;
    }
  }
}
</style>